interface Env {
  isProductionHost: boolean;
  isDevelopmentHost: boolean;
}

const host = window.location.host;

const isDevelopmentHost =
  /crm-vulnerability-assessment(\.corp-proxied)?\.dev(\.cf)?\.aws\.uw\.systems$/.test(
    host
  ) ||
  /customer-support-vulnerability-self-assessment(\.corp-proxied)?\.dev(\.cf)?\.aws\.uw\.systems$/.test(
    host
  );
const isProductionHost =
  /crm-vulnerability-assessment(\.corp-proxied)?\.prod(\.cf)?\.aws\.uw\.systems$/.test(
    host
  ) ||
  /crm-vulnerability-assessment-beta(\.corp-proxied)?\.prod(\.cf)?\.aws\.uw\.systems$/.test(
    host
  ) ||
  /customer-support-vulnerability-self-assessment(\.corp-proxied)?\.prod(\.cf)?\.aws\.uw\.systems$/.test(
    host
  );

const env: Env = {
  isProductionHost,
  isDevelopmentHost,
};

export { env };
